import { render, staticRenderFns } from "./EinstellungenModal.vue?vue&type=template&id=44624a16"
import script from "./EinstellungenModal.vue?vue&type=script&lang=js"
export * from "./EinstellungenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports